import styled from "styled-components";

import theme from "../../../common/global/theme";
import fonts from "../../../utils/fonts";
import {device} from "../../../utils/mediaQueries";

export const Container = styled.div`
  max-width: 1300px;
  margin: 40px auto;
  padding: 20px;
  background-color: ${theme.colors.white};
  color: #191818;
`;

export const MainHeading = styled.h1`
  ${fonts.lato.headingH1};
  color: #292929;
  margin-bottom: 24px;

  @media ${device.mobile} {
    font-size: 32px;
  }
`;

export const Section = styled.section`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h2`
  ${fonts.lato.headingH2};
  color: #292929;
  margin-bottom: 16px;

  @media ${device.mobile} {
    font-size: 28px;
  }
`;

export const CardTitle = styled.h3`
  ${fonts.lato.headingH3};
  color: ${theme.colors.darkBlack};

  @media ${device.mobile} {
    font-size: 28px;
  }
`;

export const SubHeading = styled.h3`
  ${fonts.lato.headingH4};
  color: #292929;
  margin-bottom: 12px;

  @media ${device.mobile} {
    font-size: 20px;
  }
`;

export const Paragraph = styled.p`
  ${fonts.lato.paragraph};
  margin-bottom: 16px;
  color: #191818;

  @media ${device.mobile} {
    font-size: 14px;
  }
`;

export const ApplicationsSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 40px;

  @media ${device.tablet} {
    flex-direction: column;
    gap: 30px;
  }

  @media ${device.mobile} {
    flex-direction: column-reverse;
    gap: 20px;
  }
`;

export const ApplicationsList = styled.div`
  flex: 1;

  @media ${device.tablet}, ${device.mobile} {
    width: 100%;
    padding: 0 20px;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 8px;

  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    display: block;
    object-fit: contain;
  }

  @media ${device.tablet} {
    justify-content: center;
  }

  @media ${device.mobile} {
    img {
      max-width: 350px;
    }
  }
`;

export const TwoColumnSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  align-items: flex-start;
  margin-bottom: 40px;

  @media ${device.tablet} {
    flex-direction: column;
    align-items: center;
  }

  @media ${device.mobile} {
    flex-direction: column;
    gap: 20px;
  }
`;

export const Column = styled.div`
  flex: 1;

  @media ${device.tablet}, ${device.mobile} {
    width: 100%;
  }
`;

export const List = styled.ul`
  list-style-type: none;
  padding-left: 0;
`;

export const ListItem = styled.li`
  ${fonts.lato.paragraph};
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: ${({color}) => (color === "blue" ? "#191818" : "#191818")};

  &::before {
    content: "";
    display: inline-block;
    width: ${({color}) => (color === "blue" ? "12px" : "8px")};
    height: ${({color}) => (color === "blue" ? "12px" : "8px")};
    margin-right: 12px;
    margin-top: ${({color}) => (color === "blue" ? "0" : "1px")};
    background-color: ${({color}) => (color === "blue" ? "#2776BB" : "#191818")};
    border-radius: ${({color}) => (color === "blue" ? "2px" : "50%")};
    flex-shrink: 0;
  }
`;

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-family: ${fonts.lato.paragraph.fontFamily};
  font-size: 14px;
  color: ${theme.colors.gray};
`;

export const Breadcrumb = styled.span`
  color: ${(props) => (props.active ? theme.colors.black : theme.colors.gray)};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};

  & + &::before {
    content: ">";
    margin: 0 8px;
    color: ${theme.colors.gray};
  }
`;
